import React, { useEffect, useRef } from 'react'
import './section-expand.css'

const SectionExpand = ({
  expanded,
  onToggle,
  controls,
  label,
  className = '',
}) => {
  const buttonRef = useRef(null)
  const cancelScrollRef = useRef(null)

  useEffect(
    () => () => {
      if (cancelScrollRef.current) cancelScrollRef.current()
    },
    []
  )

  const handleToggle = () => {
    if (cancelScrollRef.current) cancelScrollRef.current()
    const previousTop = buttonRef.current.getBoundingClientRect().top
    onToggle()
    if (expanded) {
      // Follow the shrinking list each frame, instead of jumping to its end.
      // User scrolling, resizing, or reversing the toggle takes over immediately.
      const root = document.documentElement
      const previousAnchor = root.style.overflowAnchor
      root.style.overflowAnchor = 'none'
      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
      const started = performance.now()
      let frame
      const cancel = () => {
        window.cancelAnimationFrame(frame)
        root.style.overflowAnchor = previousAnchor
        window.removeEventListener('wheel', cancel)
        window.removeEventListener('touchstart', cancel)
        window.removeEventListener('keydown', cancel)
        window.removeEventListener('resize', cancel)
        cancelScrollRef.current = null
      }
      const follow = () => {
        if (!buttonRef.current) return cancel()
        const nextTop = buttonRef.current.getBoundingClientRect().top
        window.scrollTo({
          top: window.scrollY + nextTop - previousTop,
          behavior: 'instant',
        })
        const list = document.getElementById(controls)
        const elapsed = performance.now() - started
        const moving =
          list && list.getAnimations
            ? list
                .getAnimations({ subtree: true })
                .some(
                  (animation) =>
                    animation.id === 'section-layout' ||
                    /^(height|margin-top|margin-bottom)$/.test(
                      animation.transitionProperty
                    )
                )
            : elapsed < 560
        if (!reducedMotion && elapsed < 700 && (elapsed < 80 || moving)) {
          frame = window.requestAnimationFrame(follow)
        } else {
          cancel()
        }
      }
      cancelScrollRef.current = cancel
      window.addEventListener('wheel', cancel, { passive: true })
      window.addEventListener('touchstart', cancel, { passive: true })
      window.addEventListener('keydown', cancel)
      window.addEventListener('resize', cancel)
      frame = window.requestAnimationFrame(follow)
    }
  }

  return (
    <button
      className={`SectionExpand ${className}`}
      type="button"
      ref={buttonRef}
      aria-expanded={expanded}
      aria-controls={controls}
      aria-label={`${expanded ? '收起' : '展开全部'}${label}`}
      onClick={handleToggle}
    >
      <span className="SectionExpandContent">
        <span className="SectionExpandHeading">
          <span className="SectionExpandLabel">
            {expanded ? '收起' : '展开全部'}
          </span>
          <svg viewBox="0 0 20 20" aria-hidden="true">
            <path d="M5 7.5 10 12.5 15 7.5" />
          </svg>
        </span>
      </span>
    </button>
  )
}

export default SectionExpand
